import * as React from 'react';
import { Link } from 'react-router-dom';
import { generatePath } from 'react-router';
import { MainType } from './Container';
import GrayArrow from 'Assets/Img/Icons/gray-arrow-icon.svg';
import { ROUTES } from 'shared/consts';
import AddNoteForm from './components/addNoteForm';
import { history } from 'Store/Reducers/RootReducer';

type P = {
  location: any;
  match: any;
};

class Main extends React.Component<MainType & P, any> {
  handleSubmit = async (values) => {
    await this.props.actions.addNoteToClient({ ...values, id: this.props.match.params.id });
    history.push(generatePath(ROUTES.CUSTOMER_CARD, { id: this.props.match.params.id }));
  };

  render() {
    const { params } = this.props.match;
    return (
      <div className="addCaseRemainder narrow-section">
        <div className="narrow-section__title">
          <Link to={generatePath(ROUTES.CUSTOMER_CARD, { id: params.id })}>
            <img src={GrayArrow} alt="" />
          </Link>
          <h2>Dodaj notatkę</h2>
        </div>
        <div className="add-customer__form-container">
          <AddNoteForm onSubmit={this.handleSubmit} />
        </div>
      </div>
    );
  }
}

export default Main;
